import { render, staticRenderFns } from "./LinkCollection.vue?vue&type=template&id=1f75c518"
import script from "./LinkCollection.vue?vue&type=script&lang=js"
export * from "./LinkCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports